import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function ExpertEndorsement() {
  return <Section background="white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="bg-[#FAFAF9] rounded-2xl p-8 md:p-12 border border-gray-100" data-id="element-14">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-15">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-16">
              La historia detrás de Mente de Rica
            </h2>
            <div className="w-20 h-1 bg-[#D4AF37] mx-auto" data-id="element-17"></div>
          </motion.div>

          <div className="prose prose-lg mx-auto text-gray-700 leading-relaxed" data-id="element-18">
            <p className="mb-6" data-id="element-19">
              Este programa nació cuando entendí algo incómodo:
            </p>
            <p className="font-medium text-black mb-6" data-id="element-20">
              No me faltaba capacidad. No me faltaban oportunidades. <br data-id="element-21" />
              Me faltaba una nueva identidad financiera.
            </p>
            <p className="mb-6" data-id="element-22">Me di cuenta de que:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-23">
              <li data-id="element-24">Cada vez que avanzaba, algo me frenaba</li>
              <li data-id="element-25">No era miedo al fracaso</li>
              <li data-id="element-26">Era miedo a “ser distinta” a las mujeres de mi familia</li>
            </ul>
            <p className="mb-8" data-id="element-27">
              Ahí entendí que muchas latinas no estamos bloqueadas por dinero…
              sino por lealtades invisibles.
            </p>

            <div className="bg-white p-6 rounded-lg border-l-4 border-[#D4AF37] shadow-sm" data-id="element-28">
              <p className="italic text-gray-800 font-serif text-xl" data-id="element-29">
                "Mente de Rica nació para romper ese techo invisible con amor,
                conciencia y claridad."
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}